<template>
	<div class="login-page-container" a_id="logout-container" extension-name="logout-page">
		<div class="login-page-header login-page-header-center" a_id="login-page-header">
			<span v-if="isTargetAgent" class="login-page-header-text">
				{{'LoginPage.AgentLogin' | translate}}
			</span>
			<span v-else class="login-page-header-text">
				{{'LogoutPage.LoginHeaderStart' | translate}} <b>{{'LoginPage.LoginHeaderEnd' | translate}}</b>
			</span>
		</div>
		<div>
			<div class="logout-page-reason">
				{{'LogoutPage.Reason' | translate}}
			</div>
			<div class="logout-page-reason">
				{{'LogoutPage.Action' | translate}}
			</div>
		</div>

		<div class="login-page-footer logout-page-footer" a_id="login-page-footer">
			<button class="login-page-footer-button-center"
					@click.prevent.stop="loginBtnHandler"
					a_id="login-page-footer-login-button">
				{{'LoginPage.LoginButton' | translate}}
			</button>
		</div>
	</div>
</template>

<script>
   import BasePage from './BasePage.vue';
	import UrlService from '../../../common/services/src/url/urlService';
	import LoginService from '../services/LoginService';

   export default BasePage.extend({
      name: "LogoutPage",
		props: {},
		data(){
			return {
                originalPath: '',
				isTargetAgent: LoginService.isTargetAgentApp()
			};
		},
      model: {			
			event: "navigate"
		},
      methods: {
         loginBtnHandler() {
             window.location.href = this.originalPath;
         }
      },
      mounted(){
			let originalPath = UrlService.getSearchParam('originalPath');
			if(originalPath) {
				this.originalPath = decodeURI(originalPath);
			}
		},
		dependencies: [{
			translateService : 'com.jacada.common.services.TranslateService'
		}]
	});
</script>

<style lang="scss">
	@import '../sass/loginPage.scss';
	.login-page-container {
		.logout-page-reason {
			line-height: 24px;
			font-size: 16px;
			max-width: max-content;
			margin-left: auto;
			margin-right: auto;
			float: none;
			width: auto;
			display: table;
		}
		.logout-page-footer{
			width: $form-width;
		}
		.login-page-header-center{
			margin-left: auto;
			margin-right: auto;
			.login-page-header-text {
			    display: table;
                margin: 0 auto;
			}
		}
	}
</style>




// WEBPACK FOOTER //
// src/app/LogoutPage.vue